import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll,postApproval } from "./taxOldAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  approval: [],
};

export const fetchAll = createAsyncThunk("taxOld/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const createApproval = createAsyncThunk(
  "taxOld/createApproval",
  async (payload) => {
    const response = await postApproval(payload);
    return response.data;
  }
);

export const taxOldSlice = createSlice({
  name: "taxOld",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setApproval: (state, action) => {
      state.approval = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetData, setSelected, setApproval } = taxOldSlice.actions;

export const selectData = (state) => state.taxOld.data;
export const selectLoading = (state) => state.taxOld.loading;
export const selectError = (state) => state.taxOld.error;
export const selectPageNo = (state) => state.taxOld.pageNo;
export const selectPageSize = (state) => state.taxOld.pageSize;
export const selectTotalRecord = (state) => state.taxOld.totalRecord;
export const selectSelected = (state) => state.taxOld.selected;
export const selectApproval = (state) => state.taxOld.approval;

export default taxOldSlice.reducer;
